import styled from "styled-components";
import { Overlay } from "./modals.style";
import Text from "../Text";
import Button from "../Button";
import BackgroundImage from "../../assets/bg-grid-2.png";
import LetsGoImage from "../../assets/lets-go-btn.png";
import NotYetImage from "../../assets/not-yet-btn.png";

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  padding: 50px 100px;
  z-index: 1000;
  width: 300px;
  height: 227px;
  text-align: center;
  background: url(${BackgroundImage});
  background-repeat: no-repeat;
  background-size: cover;
  background-color: #fefbed;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 30px;
`;

const StartGameModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <>
      <Overlay />
      <ModalContainer>
        <Text
          fontFamily="'Source Serif 4'"
          fontWeight="700"
          fontSize="40px"
          lineheight="100%"
          color="#3E626A"
        >
          Φύγαμε!
        </Text>
        <Text
          fontFamily="Manrope"
          fontWeight="400"
          fontSize="16px"
          lineheight="100%"
          color="#3E626A"
        >
          Είστε έτοιμοι να ξεκινήσετε την περιπέτειά σας?
        </Text>
        <div style={{ display: "inline-flex", gap: "20px" }}>
          {" "}
          <Button onClick={onClose} imgurl={NotYetImage} />
          <Button imgurl={LetsGoImage} url="/play" />
        </div>
      </ModalContainer>
    </>
  );
};

export default StartGameModal;
